import { render, staticRenderFns } from "./ConsommationPaillettes.vue?vue&type=template&id=bcc22694&"
import script from "./ConsommationPaillettes.vue?vue&type=script&lang=js&"
export * from "./ConsommationPaillettes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports